import { defineStore } from 'pinia';

interface SidebarState {
  isOpen: boolean;
}

export const useSidebarStore = defineStore('sidebar', {
  state: (): SidebarState => ({
    isOpen: true, // Por defecto el sidebar estará abierto
  }),

  actions: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    
    open() {
      this.isOpen = true;
    },
    
    close() {
      this.isOpen = false;
    },
    
    manageDocuments() {
      // Add logic for managing documents here
    },
  },
}); 